import sentry from 'legacy/utils/sentry'

import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type UpdateShipmentStatusParams = {
  shipmentUUID: string
  stopId: string | number
  type: string
  date: string
  time: string
}

export type UpdateShipmentStatusFactoryDependencies = {
  shipmentRepository: ShipmentRepository
}

export function updateShipmentStatusFactory({
  shipmentRepository,
}: UpdateShipmentStatusFactoryDependencies) {
  return async function submit(
    params: UpdateShipmentStatusParams,
    config?: { signal?: AbortSignal }
  ) {
    try {
      return await shipmentRepository.updateShipmentStatus(params, config)
    } catch (error) {
      sentry.log(error)
      throw new Error('Could not update shipment status', { cause: error as Error })
    }
  }
}

export function updateShipmentStatus(
  params: UpdateShipmentStatusParams,
  config?: { signal?: AbortSignal }
) {
  const httpClient = createAgnosticHttpClient()
  const shipmentRepository = new ShipmentRepository({ httpClient })
  const submit = updateShipmentStatusFactory({ shipmentRepository })

  return submit(params, config)
}
